import {post} from '../utils'

export default host => (id, data) => 
    post(`${host}/contentCreations/${id}/moderate`, JSON.stringify({...data}))
